import { isObject, isString } from 'lodash-es';

import type { NodeRef } from '../types';

export const isNodeRef = (value: unknown): value is NodeRef =>
  isObject(value) &&
  'externalId' in value &&
  'space' in value &&
  isString(value.externalId) &&
  isString(value.space);
